// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1200":"9a68b36cebf3d165","1979":"aa3f23f05602d722","4756":"3a976cf86b7914a6","4929":"df184f94653afb88"}[chunkId] + ".css";
};